import { useSWRFetch } from '@hooks/useSWRFetch';
import { TEN_MINUTES_IN_MS } from '@helpers/constants';
import { buildAlbumUriFromId, isEmptyString } from '@helpers/utils';
import { LiveInTerritoryAvailabilityResponse } from './types';

export const useLiveInTerritoryAvailability = (albumUri = '') => {
  const requestObject = {
    url: `v2/album/${buildAlbumUriFromId(albumUri)}/availability`,
  };

  const canRequest = !isEmptyString(albumUri);

  return useSWRFetch<LiveInTerritoryAvailabilityResponse>(
    canRequest ? requestObject : null,
    {
      dedupingInterval: TEN_MINUTES_IN_MS,
      shouldRetryOnError: false,
    },
  );
};
